module.exports = __webpack_public_path__ + "img/store.d5eea46e.png";